import { useContext } from 'react';

import { PodcastsContext } from './PodcastsContext';

export const usePodcastsContext = () => {
  const context = useContext(PodcastsContext);
  if (!context) {
    throw new Error('usePodcastsContext must be used within a PodcastsProvider');
  }
  return context;
};
